import { render } from "./HubWorkspaceHeader.vue?vue&type=template&id=37c091ba&scoped=true"
import script from "./HubWorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./HubWorkspaceHeader.vue?vue&type=script&lang=js"

import "./HubWorkspaceHeader.vue?vue&type=style&index=0&id=37c091ba&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c091ba"]])

export default __exports__